import { createFileRoute } from '@tanstack/react-router';

import { PlanAdvisorsTab } from '../../../../../components';

const Page = () => {
  const params = Route.useParams();

  return (
    <PlanAdvisorsTab
      advisoryOrganizationId={params.advisoryOrganizationId}
      planId={params.planId}
    />
  );
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/plans/$planId/advisors'
)({
  component: Page
});
